import React from 'react';
import LoaderContainer from '../LoaderContainer';
import './dotLoader.css';

function DotLoader({ text, noContainer }) {
  return noContainer ? (
    <div className='dots-3'></div>
  ) : (
    <LoaderContainer text={text}>
      <div className='dots-3'></div>
    </LoaderContainer>
  );
}

export default DotLoader;
